import { FC } from 'react';

interface LogoProps {
  width?: number;
  opacity?: number;
}

const Logo: FC<LogoProps> = ({ width = 120, opacity = 1 }) => (
  <svg xmlns='http://www.w3.org/2000/svg' xmlSpace='preserve' width={width} viewBox='0 0 181.879 84.306'>
    <g transform='translate(-69.646 -60.83)'>
      <path
        d='M162.535 111.906c-11.232 36.628-66.197 45.771-75.397 8.044-2.788-18.76 4.801-32.342 22.358-40.504-.9.171 18.92-7.974 35.494-.421 2.752.8 16.722 9.407 3.256 25.163-1.01.504-10.654 12.548-45.248 11.344-1.122-3.239-1.563-6.68-.617-10.288 41.955-1.027 39.782-14.89 29.252-17.634-19.45-2.247-35.175 12.79-29.278 28.06 1.033 5.635 12.538 35.222 60.18-3.764'
        style={{
          fill: '#0079ec',
          fillOpacity: opacity,
          stroke: 'none',
          strokeWidth: 0.499999,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='m169.596 104.082 4.745-4.33s2.78.113 3.884 0c1.104-.115 2.767-.615 2.767-.615l2.044 1.693.001 32.266s.556 4.496-3.43 8.18c-3.986 3.685-10.011 3.083-10.011 3.083zM234.85 85.315l4.441-4.541c4.794.97 7.73-.835 9.84-3.473l.002 55.417s.556 4.496-3.43 8.18c-3.986 3.685-10.853 3.083-10.853 3.083z'
        style={{
          fill: '#3393ef',
          fillOpacity: opacity,
          strokeWidth: 0.2,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M167.723 105.812c-7.896 8.981-12.501 17.763-23.171 25.119-18.656 12.862-35.912 12.005-35.912 12.005s14.422 5.622 33.065-1.927c16.405-6.644 26.018-17.759 26.018-17.759z'
        style={{
          fill: '#0054a5',
          fillOpacity: opacity,
          strokeWidth: 0.2,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='m232.528 87.24-18.895 18.786-.031.03q.1.737.1 1.48a10.922 10.922 0 0 1-21.813.824v-.211l-6.554-5.41.004 15.194 16.88 15.716 30.31-30.168z'
        style={{
          fill: '#3393ef',
          fillOpacity: opacity,
          strokeWidth: 0.2,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M169.165 91.774s-28.17 30.635-38.154 31.73c16.29 1.362 41.618-27.778 41.618-27.778zm14.49-3.034-3.751 4.562 16.47 13.615 3.75-4.563zm51.554-16.764a3.3 3.3 0 0 0-2.342.948L206.09 99.178a3.276 3.276 0 0 0-.038 4.654 3.3 3.3 0 0 0 4.67.038l26.775-26.254a3.276 3.276 0 0 0 .038-4.654 3.3 3.3 0 0 0-2.327-.986m5.805-10.735a8.32 8.32 0 0 0-8.318 8.318 8.3 8.3 0 0 0 .57 3.03 3.298 3.298 0 0 1 4.27.374 3.275 3.275 0 0 1 .29 4.28 8.3 8.3 0 0 0 3.188.634 8.32 8.32 0 0 0 8.318-8.318 8.32 8.32 0 0 0-8.318-8.318m0 4.653a3.664 3.664 0 0 1 3.664 3.665 3.664 3.664 0 0 1-3.664 3.664 3.664 3.664 0 0 1-3.664-3.664 3.664 3.664 0 0 1 3.664-3.665M176.832 80.23a8.32 8.32 0 0 0-8.319 8.318 8.3 8.3 0 0 0 .652 3.227l3.463 3.951h.001a8.3 8.3 0 0 0 4.203 1.14 8.32 8.32 0 0 0 5.187-1.815l-2.115-1.748 3.75-4.562 1.388 1.146a8.3 8.3 0 0 0 .108-1.34 8.32 8.32 0 0 0-8.318-8.317m0 4.653a3.664 3.664 0 0 1 3.664 3.665 3.664 3.664 0 0 1-3.664 3.664 3.664 3.664 0 0 1-3.665-3.664 3.664 3.664 0 0 1 3.665-3.665m25.973 14.073a8.3 8.3 0 0 0-4.88 1.582l2.199 1.817-3.75 4.563-1.699-1.404a8.3 8.3 0 0 0-.188 1.76 8.32 8.32 0 0 0 8.318 8.318 8.32 8.32 0 0 0 8.318-8.318 8.3 8.3 0 0 0-.636-3.192 3.3 3.3 0 0 1-4.434-.249 3.275 3.275 0 0 1-.259-4.322 8.3 8.3 0 0 0-2.99-.555m0 4.653a3.664 3.664 0 0 1 3.664 3.665 3.664 3.664 0 0 1-3.664 3.664 3.664 3.664 0 0 1-3.664-3.664 3.664 3.664 0 0 1 3.664-3.665'
        style={{
          opacity,
          fill: '#fff',
          fillOpacity: 1,
          strokeWidth: 0.499999,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M102.256 115.603c.732.479 4.432 24.587 39.7 10.328-33.152 17.93-47.17-5.553-50.2-11.547 5.614 1.19 6.946 1.13 10.5 1.22'
        style={{
          opacity,
          fill: '#3393ef',
          fillOpacity: opacity,
          stroke: 'none',
          strokeWidth: 0.499999,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <rect
        width={4.771}
        height={4.771}
        x={71.002}
        y={114.104}
        ry={0}
        style={{
          opacity,
          fill: '#0079ec',
          fillOpacity: 1,
          stroke: 'none',
          strokeWidth: 0.286516,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <rect
        width={5.472}
        height={5.472}
        x={79.343}
        y={107.939}
        ry={0}
        style={{
          fill: '#337bb4',
          fillOpacity: opacity,
          stroke: 'none',
          strokeWidth: 0.328651,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <rect
        width={6.525}
        height={6.525}
        x={95.282}
        y={112.986}
        ry={0}
        style={{
          fill: '#003a71',
          fillOpacity: opacity,
          stroke: 'none',
          strokeWidth: 0.391853,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <rect
        width={4.397}
        height={4.397}
        x={77.548}
        y={123.131}
        ry={0}
        style={{
          fill: '#3393ef',
          fillOpacity: opacity,
          stroke: 'none',
          strokeWidth: 0.264044,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
      <rect
        width={7.811}
        height={7.811}
        x={84.863}
        y={116.371}
        ry={0}
        style={{
          fill: '#0054a5',
          fillOpacity: opacity,
          stroke: 'none',
          strokeWidth: 0.469099,
          strokeLinecap: 'square',
          strokeLinejoin: 'round',
        }}
      />
    </g>
  </svg>
);

export { Logo };
